/**
 * The trucking rate card, `/api/v1/trucking/rates` (api#950, `trucking_rates`
 * 0474), typed to `RATE_ROW_COLUMNS` in the API's lib/trucking-rates.ts.
 *
 * Typed by hand: the response manifest recorded GET /trucking/rates against an
 * empty card, so it holds no row shape, and every write route is a refusal.
 *
 * Reads come back as stored: NUMERIC columns are strings ("3.2500"), dates are
 * `YYYY-MM-DD` calendar days. Writes are snake_case and carry only the fields
 * of the rate's kind (the API 400s TRUCKING_RATE_INVALID otherwise).
 */
export const TRUCKING_RATE_KINDS = ['haul', 'wait_time', 'fuel_surcharge', 'carrier_passthrough'] as const;
export type TruckingRateKind = (typeof TRUCKING_RATE_KINDS)[number];

export interface TruckingRate {
  id: string;
  kind: TruckingRateKind | string;
  customer_id: string | null;
  truck_id: string | null;
  load_type: string | null;
  billing_type: string | null;
  rate: string | null;
  hourly_rate: string | null;
  free_wait_minutes: number | null;
  fuel_basis: 'fixed' | 'percent' | null;
  fuel_amount: string | null;
  fuel_percent: string | null;
  markup_percent: string | null;
  currency: 'CAD' | 'USD' | string;
  effective_date: string;
  expiry_date: string | null;
  notes: string | null;
  created_at?: string;
  updated_at?: string;
  deleted_at: string | null;
}

export interface TruckingRateWrite {
  kind?: TruckingRateKind;
  customer_id?: string | null;
  truck_id?: string | null;
  load_type?: string | null;
  billing_type?: string | null;
  rate?: number | null;
  hourly_rate?: number | null;
  free_wait_minutes?: number | null;
  fuel_basis?: 'fixed' | 'percent' | null;
  fuel_amount?: number | null;
  fuel_percent?: number | null;
  markup_percent?: number | null;
  currency?: 'CAD' | 'USD';
  effective_date?: string;
  expiry_date?: string | null;
  notes?: string | null;
}

export interface TruckingRatesListResponse {
  success: boolean;
  data: TruckingRate[];
}

export interface TruckingRateResponse {
  success: boolean;
  data: TruckingRate;
}
